import type { JSX } from 'react'

import { QualityLabel } from 'atoms/Label/Templates'
import {
  TextBoxMaxLine2FontMdToSmBold,
  TextBoxMaxLine2FontXsBold,
} from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import {
  StreamingOptionItemInnerSC,
  StreamingOptionItemSC,
  StreamingOptionLeftSC,
  StreamingOptionLogoBoxSC,
  StreamingOptionLogoImgSC,
  StreamingOptionTextsSC,
} from './StreamingOptionItem.styled'

export interface IStreamingOptionItemProps {
  serviceName: string
  subtitle: string
  logoUrl?: string
  quality?: string | null
  onClick?: () => void
}

export function StreamingOptionItem({
  serviceName,
  subtitle,
  logoUrl,
  quality,
  onClick,
}: IStreamingOptionItemProps): JSX.Element {
  return (
    <StreamingOptionItemSC type='button' onClick={onClick}>
      <StreamingOptionItemInnerSC>
        <StreamingOptionLeftSC>
          <StreamingOptionLogoBoxSC aria-hidden={!logoUrl}>
            {logoUrl ? <StreamingOptionLogoImgSC src={logoUrl} alt='' /> : null}
          </StreamingOptionLogoBoxSC>
          <StreamingOptionTextsSC>
            <TextBoxMaxLine2FontMdToSmBold title={serviceName} />
            {subtitle ? (
              <TextBoxMaxLine2FontXsBold
                title={subtitle}
                color={Colors.TEXT_ICON_SECONDARY}
              />
            ) : null}
          </StreamingOptionTextsSC>
        </StreamingOptionLeftSC>
        {quality ? <QualityLabel title={quality} /> : null}
      </StreamingOptionItemInnerSC>
    </StreamingOptionItemSC>
  )
}
